import api from "../redux/apis/api";

function triggerBrowserDownload(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(url);
}

export async function downloadInventoryTemplate(preset) {
  const cleanPreset = String(preset || "").trim().toLowerCase();
  const response = await api.get(`/inventory/import/template?preset=${encodeURIComponent(cleanPreset)}`, {
    responseType: "blob",
  });
  triggerBrowserDownload(response.data, `inventory_${cleanPreset}_template.xlsx`);
}

export async function uploadInventoryFile(preset, file, { validateOnly = false } = {}) {
  const cleanPreset = String(preset || "").trim().toLowerCase();
  const form = new FormData();
  form.append("file", file);

  const { data } = await api.post(
    `/inventory/import/upload?preset=${encodeURIComponent(cleanPreset)}&validateOnly=${validateOnly ? "true" : "false"}`,
    form,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );

  return data;
}
